import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const requireCheckboxesCheckedValidator = (minRequired = 1): ValidatorFn => {
  const validate = (formGroup: UntypedFormGroup) => {
    let checked = 0;

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];

      if (control.value === true) {
        checked++;
      }
    });

    if (checked < minRequired) {
      return {
        requireCheckboxesChecked: true,
      };
    }

    return null;
  };
  return validate;
};
